import { baseEach } from './base'

export default function forEach(data, iteratee) {
  return baseEach(data, iteratee)
}
